import { Skeleton } from "@tellescope/ui";

/**
 * Loading skeleton for legacy pages while they're being lazy loaded.
 */
export const LegacyPageSkeleton = () => (
  <div className="container mx-auto px-4 py-6 max-w-3xl space-y-4">
    <Skeleton className="h-8 w-48" />
    <Skeleton className="h-32 w-full" />
    <Skeleton className="h-32 w-full" />
  </div>
);
